/** Display labels for practice session `mode` values stored as verbal | text in the API. */
export type PracticeMode = 'verbal' | 'text';

export const PRACTICE_MODE_LABELS: Record<PracticeMode, string> = {
  verbal: 'Video Call',
  text: 'Chat Practice',
};

export function practiceModeLabel(mode: PracticeMode): string {
  return PRACTICE_MODE_LABELS[mode];
}
